module.exports = __webpack_public_path__ + "media/images/img-architect-95537c70b0edcd1e9a8819f8d7750d31.svg";